import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { slideInAnimation } from 'src/app/core/models/animations';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { GroupSharingService } from 'src/app/features/group-sharing/group-sharing.service.component';

@Component({
    selector: 'app-spotlight-root',
    templateUrl: './spotlight-root.component.html',
    styleUrls: ['./spotlight-root.component.scss']
})
export class SpotlightRootComponent implements OnInit {
    eventId: any;
    premiere: any;
    showThetre: boolean = false;
    showRedCarpert: boolean = false;
    showGSLobby: boolean = false;
    showGSQALobby: boolean = false;
    isGroupSharingActive:boolean=false;
    hideGroupSharing:boolean=true;
    refresh = false
    constructor(
        private route: ActivatedRoute,
        public router: Router,
        private spotlightService: SpotlightService,
        private gsService: GroupSharingService) {
        this.eventId = route.snapshot.params.id;
    }

    ngOnInit(): void {
        this.gsService.subscribeToEventWatchParty(this.eventId)
        this.getEventDetails()
      
    }

    getEventDetails(): void {
        this.spotlightService.cmsGetPremierdeatails(this.eventId).subscribe((response2) => {
                this.premiere = response2;
                setInterval(() => {
                    this.redirect()
                }, 1000)
            }, err => {

            });
    }

    redirect(): void {
        let userAgent = navigator.userAgent;
        let browserName;
        if (userAgent.match(/firefox|fxios/i)) {
            browserName = "Firefox";
            alert("Hi,\nFor a better experience please use Google Chrome, Safari or Microsoft Edge.\n\nThank you!")
        }
        const currentTimeText = Date.now();
        const groupSharingSchedule = this.premiere.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'GS1')
        const redCarpetSchedule = this.premiere.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'Red Carpet');
        const groupSharingScheduleQA = this.premiere.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'GS2');
        const openingRemarks = this.premiere.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'Opening Remarks');
        if(currentTimeText >= this.premiere.cinejoySpotlightsSchedule[6].scheduleTimeText){
            this.showGSLobby = false;
            this.showRedCarpert = false;
            this.showThetre = true;
            this.showGSQALobby = false;
            this.hideGroupSharing=true;
            return
        }
        if (redCarpetSchedule === undefined || redCarpetSchedule === null) {
            this.showThetre = true;
        } else {
            if ((groupSharingSchedule.scheduleTimeText <= currentTimeText) && (currentTimeText <= redCarpetSchedule.scheduleTimeText)) {
                this.showGSLobby = true;
                this.showRedCarpert = false;
                this.showThetre = false;
                this.showGSQALobby = false;
                this.hideGroupSharing=false;
                this.refresh = true
            } else if ((redCarpetSchedule.scheduleTimeText <= currentTimeText) && (this.premiere.cinejoySpotlightsSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
                if(this.refresh){
                    this.refresh = false
                    window.location.reload()
                }
                this.refresh = false
                this.showGSLobby = false;
                setTimeout(()=>{
                    this.refresh = false
                    this.showRedCarpert = true;
                },2000)
                this.showThetre = false;
                this.showGSQALobby = false;
                this.hideGroupSharing=false;
            } else if (groupSharingScheduleQA.scheduleTimeText <= currentTimeText) {
                if(this.refresh){
                    this.refresh = false
                    window.location.reload()
                }
                this.refresh = false
                this.showGSLobby = false;
                this.showRedCarpert = false;
                this.showThetre = false;
                this.showGSQALobby = true;
                this.hideGroupSharing=false
            } else {
                if(this.refresh){
                    this.refresh = false
                    window.location.reload()
                }
                this.refresh = false
                this.showGSLobby = false;
                this.showRedCarpert = false;
                this.showThetre = true;
                this.showGSQALobby = false;
                this.hideGroupSharing=false;
            }
        }
    }

    getRedCarpetIndex(): number {
        let i = 0;
        for (const schedule of this.premiere.cinejoySpotlightsSchedule) {
            if (schedule.scheduleMainText === 'Red Carpet') {
                break;
            }
            i++;
        }
        return i;
    }

    isGroupShareActive(event) {
        console.log(event)
         this.gsService.groupSharingActive.next(event);
    }
}
